////////LIBRARY/////////
import { useEffect, useState } from 'react'

function UseWindowResize() {
	const [dimensions, setDimensions] = useState({
		height: window.innerHeight,
		width: window.innerWidth,
	})

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleScroll = () => {
		setDimensions({
			height: window.innerHeight,
			width: window.innerWidth,
		})
	}

	// This function handle the scroll performance issue
	const debounce = (func, wait = 500, immediate = false) => {
		let timeOut
		return () => {
			let context = this,
				args = arguments
			const later = () => {
				timeOut = null
				if (!immediate) func.apply(context, args)
			}
			const callNow = immediate && !timeOut
			clearTimeout(timeOut)
			timeOut = setTimeout(later, wait)
			if (callNow) func.apply(context, args)
		}
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		window.addEventListener('resize', debounce(handleScroll))
	}, [])

	useEffect(() => {
		return () => {
			window.removeEventListener('resize', () => handleScroll)
		}
	}, [handleScroll])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return [dimensions]
}

export default UseWindowResize
